/**
 * Keeps the Backorder badge in step with the selected variant.
 *
 * The backorder flag is a per-variant metafield, so the server-rendered badge is
 * only correct for the variant the page loads with. The theme dispatches
 * `variant:changed` (assets/theme.js) and snippets/product-meta.liquid is the
 * existing consumer this mirrors.
 *
 * No-ops when the data blob is absent, so every product without backorder flags
 * is completely untouched.
 */
(function () {
  var blob = document.querySelector('script[type="application/json"][data-ebk-availability]');
  if (!blob) return;

  var data;
  try {
    data = JSON.parse(blob.textContent || '{}');
  } catch (e) {
    console.error('ebk-availability: could not parse variant data', e);
    return;
  }

  function paint(variantId) {
    var wrap = document.querySelector('[data-ebk-backorder]');
    if (!wrap) return;
    var state = data[String(variantId)];
    var lead = wrap.querySelector('[data-ebk-backorder-lead]');
    if (state && state.backorder) {
      // Empty lead text is legitimate (Adam can flag backorder without a date),
      // so fall back to whatever the server rendered rather than blanking it.
      if (lead && state.lead) lead.textContent = state.lead;
      wrap.hidden = false;
    } else {
      wrap.hidden = true;
    }
  }

  document.addEventListener('variant:changed', function (ev) {
    var d = ev && ev.detail;
    var variant = d && (d.variant || d);
    if (variant && variant.id) paint(variant.id);
  });
})();
